/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Common_VersionInputs */

const en_fc_common_version = /** @type {(inputs: Fc_Common_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest version`)
};

/**
* | output |
* | --- |
* | "Latest version" |
*
* @param {Fc_Common_VersionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_common_version = /** @type {((inputs?: Fc_Common_VersionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Common_VersionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_common_version(inputs)
});
export { fc_common_version as "fc.common.version" }